<template>
    <div class="backoffice-footer" v-if="me.profile.sub != ''">
        <b-container fluid>
            <div class="user-info">
                    Operatore: <b>{{me.profile.sub}}</b>
                    <span v-if="me.is_admin"> (admin)</span>
                    <!--<span v-if="!me.is_admin">(non-admin)</span>-->
            </div>
        </b-container>
    </div>
</template>

<script>
    import {get_me} from "@/api";

    export default {
        name: 'backoffice-footer',
        props: {
        },
        computed: {
        },
        data() {
            return {
                me: get_me(),
            }
        },
        components: {
        },
        methods:
        {
        },
    }
</script>

<style lang="scss">
    .user-info
    {
        font-size: 12px;
    }
    .backoffice-footer
    {
        background-color: #ebebeb;
        padding:10px;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: left;
    }
    .navigation
    {
        margin:0;
        padding:0;
        list-style:none;
        display: flex;
        align-items: center;
        justify-content: center;
        li
        {
            margin-right:1rem;
        }
        a
        {
            display: block;
            color:$white;
            background:$secondary;
            padding:10px 20px;
            transition:$transition-base;
            text-transform: uppercase;
            font-size: 16px;
            &:hover
            {
                color:$white;
                background:$info;
                text-decoration: none;
            }
        }
    }
</style>